import { UidMap } from '~/constants';

export function useUidUtils() {
    const uidMap = new Map(Object.entries(UidMap));
    // const uidTypeMap = new Map(Object.entries(UidTypeMap));

    function getTypeByUid(uid?: Nilish<string>): Nilish<string> {
        if (!uid) return;
        const pfx = uid.split('_');
        return uidMap.get(`${pfx[0]}`);
    }

    function isUidOfType(type: string, uid: string): boolean {
        return type === getTypeByUid(uid);
    }

    return {
        uidMap,
        getTypeByUid,
        isUidOfType
    };
}
